export const SOCKET_ENDPOINT = process.env.LIVECASTS_SOCKET_ENDPOINT;
export const IMGIX_HOST = process.env.LIVECASTS_IMGIX_HOST;
